// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1mz3a","calendarButtons":"ClockData_calendarButtons__YMAFZ"};